import { Countries } from '../../shared/libraries/countries';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class PhoneUpdateSerializer extends BaseSerializer {
  normalize(phoneNumber, countryCode = '', ) {
    let phone = (phoneNumber || "").toString().replace(/\D/g, "");
    let pre = "";

    if (countryCode) {
      const country = Countries.find(countryCode);
      if (country) {
        pre = (country.phonePrefix || country.callingCode || "").toString().replace(/\D/g, "");
      }
    }

    if (pre && !phone.startsWith(pre)) {
      phone = `${pre}${phone}`;
    }

    // Benin 10-digit rule: add 01
    if (phone.startsWith("229") && phone.length === 11) {
      phone = "22901" + phone.substring(3);
    }
    return phone;
  }

  serializeCollect(data, userData) {
    const normalizedPhone = this.normalize(data.phoneNumber, data.countryCode);
    return {
      id: Date.now(),
      requestId: `phone-verify-${Date.now()}`,
      service: '1bpay',
      lastName: userData.lastName || userData.username || 'Client',
      firstName: userData.firstName || userData.username || 'Client',
      amount: data.amount || 100,
      countryCode: data.countryCode || 'BJ',
      processor: data.operator,
      currency: 'XOF',
      phoneNumber: normalizedPhone,
      narration: `Validation de numéro 1BPAY`
    };
  }

  deserializeStatus(res) {
    const status = res.data?.data?.status || res.data?.status || null;
    return {
      success: status === 'success',
      status: status
    };
  }

  serializeSave(phones) {
    return {
      appInfo: {
        phones: phones
      }
    };
  }

  deserializeCheck(res) {
    return res.data?.data?.appInfo?.phones || [];
  }
}

export const phoneUpdateSerializer = new PhoneUpdateSerializer();
